import { useMediaQuery } from '@gv/triage-components';

const wideScreenWidth = 1680;

export const isWideScreenHook = () =>
  useMediaQuery({ minWidth: wideScreenWidth });
